import { useController, UseFormReturn } from 'react-hook-form';
import { Typeahead } from 'react-bootstrap-typeahead';

import 'react-bootstrap-typeahead/css/Typeahead.css';

type Props = {
  name: string;
  control: UseFormReturn<any>['control'];
  required?: boolean;
  placeholder?: string;
  /**
   * List of options to be shown to the users for selecting
   */
  options: any;
  ariaLabel?: string;
  multiple?: boolean;
  allowNew?: boolean;
  newSelectionPrefix?: string;
};

/**
 * BootstrapTypeahead
 *
 * A react hook form field that implements the Bootstrap Typeahead component.
 *
 * @link http://ericgio.github.io/react-bootstrap-typeahead/
 */
export default function BootstrapTypeahead({
  name,
  control,
  required,
  placeholder,
  options,
  ariaLabel,
  multiple = false,
  allowNew = false,
  newSelectionPrefix = 'Add a new tag: ',
}: Props) {
  const {
    field: { onChange, onBlur, value },
    // formState: { isValid, touchedFields },
  } = useController({ name, control, rules: { required } });

  const handleOnChange = (values) => {
    if (allowNew) {
      const transformedValue = values.map((v) =>
        v.customOption ? v.label : v,
      );
      onChange(transformedValue);
    } else {
      onChange(values);
    }
  };

  return (
    <Typeahead
      // isInvalid={touchedFields[name] && !isValid}
      clearButton
      // isValid={isValid}
      multiple={multiple}
      onBlur={onBlur}
      onChange={handleOnChange}
      options={options}
      placeholder={placeholder}
      selected={value}
      id={`${name}ID`}
      allowNew={allowNew}
      newSelectionPrefix={newSelectionPrefix}
      inputProps={
        {
          'aria-labelledby': ariaLabel,
          'data-testid': name,
        } as unknown
      }
    />
  );
}
